<template>
    <div class="h5-wrapper">
        <div class="content">
            <!--内容部分-->
            <router-view></router-view>
        </div>
        <nav class="tabbar">
            <router-link to="/Article">面经</router-link>
            <router-link to="/Collect">收藏</router-link>
            <router-link to="/Like">喜欢</router-link>
            <router-link to="/User">我的</router-link>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'LayoutPage',
    // 被 keep-alive 缓存了，再次进入不会执行
    created() {
        console.log('created')
    },
    mounted() {
        console.log('mounted')
    },
    destroyed() {
        console.log('destroyed')
    },

    // 被 keep-alive 缓存，   进入会激活，离开会失活
    activated() {
        console.log('activated')
    },
    deactivated() {
        console.log('deactivated')
    }
}
</script>

<style>
body {
    margin: 0;
    padding: 0;
}
</style>
<style lang="less" scoped>
.h5-wrapper {
    .content {
        margin-bottom: 51px;
    }

    .tabbar {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        display: flex;
        background: #fff;
        border-top: 1px solid #e4e4e4;

        a {
            flex: 1;
            text-decoration: none;
            font-size: 14px;
            color: #333;
            -webkit-tap-highlight-color: transparent;
        }

        /*需要高亮*/

        a.router-link-active {
            color: orange;
        }
    }
}
</style>